import { Skeleton, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, Fragment } from 'react';

import CommunityIcon from '@/assets/icons/ic-community.svg';
import ExpoIcon from '@/assets/icons/ic-nav-expo.svg';
import HelpDeskIcon from '@/assets/icons/ic-nav-help-desk.svg';
import LoungeIcon from '@/assets/icons/ic-nav-lounge.svg';
import MainStageIcon from '@/assets/icons/ic-nav-main-stage.svg';
import PostersIcon from '@/assets/icons/ic-nav-posters.svg';
import ReceptionIcon from '@/assets/icons/ic-nav-reception.svg';
import ScheduleIcon from '@/assets/icons/ic-nav-schedule.svg';
import SessionsIcon from '@/assets/icons/ic-nav-sessions.svg';

import {
  getActiveNavigationRoute,
  getOrderedNavigationItems,
  NAVIGATION_ITEMS,
} from '@/constants/event-app-navigation-items';
import { IEventConfiguration } from '@/resources/upgrade/EventConfiguration';

import { EventNavigationItem } from '../EventNavigationItem/EventNavigationItem';

const iconLookupTable = new Map([
  ['reception', ReceptionIcon],
  ['schedule', ScheduleIcon],
  ['mainStage', MainStageIcon],
  ['sessions', SessionsIcon],
  ['posters', PostersIcon],
  ['expo', ExpoIcon],
  ['lounge', LoungeIcon],
  ['community', CommunityIcon],
  ['helpdesk', HelpDeskIcon],
]);

export const PrimaryNavigationItems: FC<{
  eventConfiguration: IEventConfiguration;
  eventId: string | Array<string>;
  currentRoute: string;
  enableTooltip: boolean;
}> = ({ eventConfiguration, eventId, currentRoute, enableTooltip }) => {
  if (!eventConfiguration) {
    return (
      <Fragment>
        {NAVIGATION_ITEMS.map(({ id }) => (
          <Skeleton key={id} h="14" w="14" flexShrink={0} _notLast={{ mb: 2 }} />
        ))}
      </Fragment>
    );
  }

  const orderedItems = getOrderedNavigationItems(eventConfiguration);
  const activeRoute = getActiveNavigationRoute(currentRoute);

  return (
    <Fragment>
      {orderedItems.map(({ id, route, labelKey }) => {
        const Icon = iconLookupTable.get(id);
        const label = (eventConfiguration[labelKey] as string) || id;

        return (
          <NextLink key={id} href={`/events/${eventId}${route}`} passHref legacyBehavior>
            <EventNavigationItem
              isActive={activeRoute === route}
              Icon={<Icon height="1.5rem" width="1.5rem" />}
              enableTooltip={enableTooltip}
              aria-label={`Go to ${label}`}
              mb="2"
            >
              <Text as="span" fontSize="md" lineHeight="base" textTransform="capitalize">
                {label}
              </Text>
            </EventNavigationItem>
          </NextLink>
        );
      })}
    </Fragment>
  );
};
